import styled from 'styled-components'

import { Anchor } from '~/components/atoms'

export const HeavyAnchor = styled(Anchor)`
	font-weight: ${(p) => p.theme.font.sans.weight.bold};
`
